export const REPORT_TIME_ZONE = "Europe/Istanbul";

export const getReportDateKey = (date = new Date()) => {
  const normalizedDate = date?.toDate instanceof Function
    ? date.toDate()
    : date instanceof Date
      ? date
      : new Date(date);

  return normalizedDate.toLocaleDateString("tr-TR", {
    timeZone: REPORT_TIME_ZONE,
  });
};

export const roundMoney = (value) =>
  Math.round((Number(value) || 0) * 100) / 100;

export const paymentFieldForType = (type) => {
  if (type === "Nakit") return "nakit";
  if (type === "Kredi Kartı") return "kredi";
  if (["Sodexo", "Multinet", "Edenred", "Metropol"].includes(type)) {
    return "mealCard";
  }
  return null;
};

export const createEmptySales = () => ({
  sales: {},
  sayı: 0,
  nakit: 0,
  kredi: 0,
  mealCard: 0,
  paket: 0,
  arama: 0,
  discountAmount: 0,
});

export const normalizeSales = (data = {}) => ({
  ...createEmptySales(),
  ...data,
  sales: { ...(data.sales || {}) },
});

export const applyItemDelta = (sales, items = [], direction = 1) => {
  items.forEach((item) => {
    const mealId = item.meal || item.mealId;
    if (!mealId) return;
    const quantity = Number(item.quantity) || 0;
    sales.sales[mealId] = (Number(sales.sales[mealId]) || 0) + quantity * direction;
  });
};

export const applyPaymentDelta = (sales, payments = []) => {
  payments.forEach((payment) => {
    const field = paymentFieldForType(payment.type);
    if (field) {
      sales[field] = roundMoney(
        (Number(sales[field]) || 0) + (Number(payment.amount) || 0)
      );
    }
    if (payment.type === "İndirim") {
      sales.discountAmount = roundMoney(
        (Number(sales.discountAmount) || 0) + (Number(payment.amount) || 0)
      );
    }
  });
};
